import { z } from 'zod';
/** Tüm hata yanıtlarının ortak biçimi. */
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        /** Alan bazlı doğrulama hataları: { "barcode": "zorunlu" } */
        fields: z.record(z.string()).optional(),
    }),
});
/**
 * Cursor tabanlı sayfalama. Offset kullanmıyoruz: yeni kayıt eklendikçe
 * offset kayar ve kullanıcı aynı satırı iki kez görür. Cursor'da bu olmaz.
 */
export const paginationQuerySchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const uuidSchema = z.string().uuid();
//# sourceMappingURL=common.js.map